module.exports = __webpack_public_path__ + "img/encom-transp.97fe5ea7.png";